import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 12px;
`;
